/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
// export const urls="http://47.104.173.17:9002/evaluate"
// export const urls="http://192.168.0.196:9002/evaluate"
import { POST, DWON } from "../api/index";
export const BASE_URL = process.env.BASE_URL; // 引入全局url，定义在全局变量process.env中，值为空字符串
export const urls = BASE_URL + "/evaluate";
// export const dapingurl = "http://beta.cvg.jingshidata.com"; //大屏测试
// export const zongpingurl = "http://beta.sso.jingshidata.com"; //综评测试
// export const dataurl = "http://beta.data.jingshidata.com"; //大屏测试
// export const previewUrl = "http://beta.report.jingshidata.com/#/"; //报告册 报告单预览
// export const tiaozhuans = "http://beta.account.51xiaoping.com/#/"; //报告册 报告单预览
// export const tui = "http://beta.home.jingshidata.com/#/"; //报告册 报告单预览

export const dapingurl = "http://cvg.read.jingshidata.com"; //阅读大屏正式
export const zongpingurl = "http://sso.jingshidata.com"; //综评测试
export const dataurl = "http://data.jingshidata.com"; //大屏测试
export const previewUrl = "https://report.jingshidata.com/#/"; //报告册 报告单预览
export const tiaozhuans = "http://account.jingshidata.com/#/"; //报告册 报告单预览
export const tui = "http://www.jingshidata.com/#/"; //报告册 报告单预览

//获取学校已开通应用列表
export function getAppList(params) {
  return POST(urls + "/usercenter/get-myapp-list", params, "get", "");
}
//获取登陆用户信息
export function UsercenterGetInfo() {
  return POST(urls + "/usercenter/get-info", "", "get", "");
}
//登陆用户:查询自己全部角色权限菜单GET /menu/tree-by-roley
export function MenuTreeByUser(params) {
  return POST(urls + "/menu/tree-by-role", params, "get", "");
}
//退出登录
export function UserLogout() {
  return POST(urls + "/user/logout", "", "post", "");
}
//活动-列表
export function activitylist(params) {
  return POST(urls + "/activity/list", params, "get", "");
}
//活动-活动结果上
export const activityresultupload = urls + "/activity/result/upload";
//活动-活动结果列表
export function activityresultlist(params) {
  return POST(urls + "/activity/result/list", params, "get", "");
}
//活动-活动结果清空
export function activityresultdel(params) {
  return POST(urls + "/activity/result/del", params, "get", "");
}
//活动-删除活动
export function activitydel(params) {
  return POST(urls + "/activity/del", params, "get", "");
}
//获取登陆用户信息
export function usercenterinfo() {
  return POST(urls + "/usercenter/get-info", "", "get", "");
}
//教师列表
export function teacherlist(params) {
  return POST(urls + "/teacher/list", params, "get", "");
}
//行为管理-行为列表
export function punishactionlist() {
  return POST(urls + "/punish/action/list", "", "get", "");
}
//评价指标-根据学校ID获取评价指标树结构
export function nodesgetlist(params) {
  return POST(urls + "/nodes/get-list", params, "get", "");
}
//评价指标-根据学校ID获取评价指标树结构1
export function nodesgetlisttype(params) {
  return POST(urls + "/nodes/get-list-by-type", params, "get", "");
}
//行为管理-添加
export function punishactionsave(params) {
  return POST(urls + "/punish/action/save", params, "post", "");
}
//行为管理-删除
export function punishactiondel(params) {
  return POST(urls + "/punish/action/del", params, "delete", "");
}
//获取历史学期
export function yearhistorylist() {
  return POST(urls + "/year/get-history-list", "", "get", "");
}
//底线清单-列表
export function punishlist(params) {
  return POST(urls + "/punish/list", params, "get", "");
}
//获取学生ID和姓名列表
export function studentsimplelist(params) {
  return POST(urls + "/student/list", params, "get", "");
}
//底线清单-保存
export function punishsave(params) {
  return POST(urls + "/punish/save", params, "post", "");
}
//活动-保存
export function activitysave(params) {
  return POST(urls + "/activity/save", params, "post", "");
}
//数据库字典
export function dictcode(params) {
  return POST(urls + "/dict/code", params, "get", "");
}
//评价模板-获取学校使用的评价模板
export function templategetTemplate() {
  return POST(urls + "/template/getTemplate", "", "get", "");
}
//评价阶段—根据模板ID获取评价阶段时间轴
export function stagetemptime(params) {
  return POST(urls + "/stage/temp-time-line", params, "get", "");
}
//评价模板-根据模板ID获取应用审核设置结果
export function templateauditlist(params) {
  return POST(urls + "/template/audit/set-list", params, "get", "");
}
//第三方应用
export function appevalist() {
  return POST(urls + "/app/eva-list", "", "get", "");
}
//评价模板-根据模板ID获取综合评定设置
export function templaterulesid(params) {
  return POST(urls + "/template/rules/" + params.id, "", "get", "");
}
//评价模板-获取所有综合评定形式
export function templateruleslist() {
  return POST(urls + "/template/rules/list", "", "get", "");
}
//评价小组-查询评价小组列表
export function evagrouplist(params) {
  return POST(urls + "/eva/group/list", params, "get", "");
}
//获取班级详细信息列表【分页】
export function classeslist(params) {
  return POST(urls + "/classes/list", params, "get", "");
}
//评价小组-新增/修改评价小组
export function evagroup(params) {
  return POST(urls + "/eva/group", params, "post", "");
}
//年级列表
export function gradegradelist(params) {
  return POST(urls + "/grade/gradelist", params, "get", "");
}
//评价指标-根据学校ID获取评价指标树结构【带课程列表】
export function getnodecourselist(params) {
  return POST(urls + "/nodes/get-node-course-list", params, "get", "");
}
//好习惯-获取学校好习惯列表
export function habitlist(params) {
  return POST(urls + "/habit/school/list", params, "get", "");
}
//统计管理-好习惯统计
export function statisticssearchhabit(params) {
  return POST(urls + "/statistics/search/habit", params, "get", "");
}
//统计管理-审核统计
export function statisticssearchauditing(params) {
  return POST(urls + "/statistics/search/auditing", params, "get", "");
}
//好习惯-获取学生好习惯详情
export function tchhabitdetail(params) {
  return POST(urls + "/tch/habit/detail", params, "get", "");
}
//好习惯-获取列表
export function tchhabitlist(params) {
  return POST(urls + "/tch/habit/list", params, "get", "");
}
//获取教师所任班级列表
export function teacherclasseslist(params) {
  return POST(urls + "/teacher/classes/list-by-work", params, "get", "");
}
//教师评价管理-成绩列表
export function tchmanagerlist(params) {
  return POST(urls + "/tch/manager/list", params, "get", "");
}
//底线清单-删除
export function punishdel(params) {
  return POST(urls + "/punish/del", params, "delete", "");
}
//评价小组-删除评价小组
export function evagroupsd(params) {
  return POST(urls + "/eva/group/" + params.id, params, "delete", "");
}
//统计管理-好习惯详情
export function statisticssearchhabitdetail(params) {
  return POST(urls + "/statistics/search/habit/detail", params, "get", "");
}
//统计管理-审核进度列表
export function statisticssearchauditingdetail(params) {
  return POST(urls + "/statistics/search/auditing/detail", params, "get", "");
}
//一级指标
export function energylist(params) {
  return POST(urls + "/energy/list", params, "get", "");
}
//统计管理-班级审核结果导出
export const statisticsexportauditingdetail =
  urls + "/statistics/export/auditing/detail";
//活动-活动结果模板下载
export const activityresultdownload = urls + "/activity/result/download";
//好习惯结果导出
export const exportsearchhabitdetail =
  urls + "/statistics/export/search/habit/detail";
//好习惯结果导出
export const exportsearchhabit = urls + "/statistics/export/search/habit";
//教师评价管理-下载成绩模板
export const tchmanagerdownload = urls + "/tch/manager/download/template";
//教师评价管理-导入成绩
export const tchmanagerimportscore = urls + "/tch/manager/import/score";
//统计管理-审核统计导出
export const statisticsexportauditing = urls + "/statistics/export/auditing";
//荣誉管理-荣誉结果导出
export const honourrecordexport = urls + "/honour/record/export";
//荣誉管理-评价整体导出
export const honourgrantlistexport = urls + "/honour/grant/list/export";
//老师审核管理-列表
export function tchauditlist(params) {
  return POST(urls + "/tch/audit/list", params, "get", "");
}
//老师审核管理-审核详情
export function tchauditdetail(params) {
  return POST(urls + "/tch/audit/detail", params, "get", "");
}
//老师审核管理-更新状态-单条
export function tchauditupdatestatus(params) {
  return POST(urls + "/tch/audit/update/status", params, "get", "");
}
//评价指标-获取学校指定等级指标
export function modellistrole(params) {
  return POST(urls + "/model/list-by-role", params, "get", "");
}
//GET综评设置-进阶等级列表
export function settingappletrankslist(params) {
  return POST(urls + "/setting/applet/ranks/list", params, "get", "");
}
//综评设置-进阶等级保存
export function settingappletrankssave(params) {
  return POST(urls + "/setting/applet/ranks/save", params, "post", "");
}
//综评设置-进阶等级列表
export function settingappletranksadd(params) {
  return POST(urls + "/setting/applet/ranks/add", params, "get", "");
}
//综评设置-小程序菜单列表
export function settingappletmenulist() {
  return POST(urls + "/setting/applet/menu/list", "", "get", "");
}
//oss文件上传
export const fileossupload = urls + "/file/oss-upload";
//综评设置-小程序菜单编辑
export function settingappletmenuupdate(params) {
  return POST(urls + "/setting/applet/menu/update", params, "post", "");
}
//综评设置-小程序自定义图片列表
export function settingappletpiclist() {
  return POST(urls + "/setting/applet/pic/list", "", "get", "");
}
//综评设置-小程序自定义图片广告位
export function settingappletadpostion() {
  return POST(urls + "/setting/applet/ad/postion", "", "get", "");
}
//综评设置-小程序自定义图片上传图片
export function settingappletpicupload(params) {
  return POST(urls + "/setting/applet/pic/upload", params, "post", "");
}
//综评设置-小程序自定义图片删除图片
export function settingappletpicdel(params) {
  return POST(urls + "/setting/applet/pic/del", params, "get", "");
}
//综评设置-进阶等级删除
export function settingappletranksdel(params) {
  return POST(urls + "/setting/applet/ranks/del", params, "get", "");
}
//获取班级列表【不分页】
export function classessimplelist(params) {
  return POST(urls + "/classes/simple/list", params, "get", "");
}
//GET /setting/honour/list综评设置-荣誉列表
export function settinghonourlist(params) {
  return POST(urls + "/setting/honour/list", params, "get", "");
}
//综评设置-荣誉保存
export function settinghonoursave(params) {
  return POST(urls + "/setting/honour/save", params, "post", "");
}
//综评设置-荣誉保存
export function settinghonourdel(params) {
  return POST(urls + "/setting/honour/del", params, "get", "");
}
//荣誉管理-荣誉记录列表
export function honourrecordlist(params) {
  return POST(urls + "/honour/record/list", params, "get", "");
}
//荣誉管理-荣誉授予列表
export function honourgrantlist(params) {
  return POST(urls + "/honour/grant/list", params, "get", "");
}
//荣誉管理-荣誉结果删除
export function honourrecorddel(params) {
  return POST(urls + "/honour/record/del?id=" + params.id, "", "post", "");
}
//荣誉管理-荣誉结果保存
export function honourrecordsave(params) {
  return POST(urls + "/honour/record/save", params, "post", "");
}
//荣誉管理-荣誉结果保存 批量
export function honourrecordbatch(params) {
  return POST(urls + "/honour/batch/record/save", params, "post", "");
}

///teacher/classes/list-by-classes-group
export function teacherclassesclassesgroup(params) {
  return POST(
    urls + "/teacher/classes/list-by-classes-group",
    params,
    "get",
    ""
  );
}
//获取公告列表GET /notice/list
export function noticelist(params) {
  return POST(urls + "/notice/list", params, "get", "");
}
//查看公告详情GET /notice/{id}
export function notice(params) {
  return POST(urls + "/notice/" + params.id, "", "get", "");
}
//老师审核管理内容详情列表
export function tchauditdetaillist(params) {
  return POST(urls + "/tch/audit/list/detail", params, "get", "");
}
//老师审核管理-更新状态
export function tchauditbatchupdatestatus(params) {
  return POST(urls + "/tch/audit/batch/update/status", params, "get", "");
}
//习惯养成-习惯养成列表
export function tchhabitlistdetail(params) {
  return POST(urls + "/tch/habit/list/detail", params, "get", "");
}
//习惯养成-导出报告
export const tchhabitlistdetailexport = urls + "/tch/habit/list/detail/export";
//获取学科列表
export function subjectlist() {
  return POST(urls + "/subject/list", "", "get", "");
}
//通过xuexiaoid获取学科列表
export function subjectlistBySchoolId(params) {
  return POST(urls + "/subject/getSubjectBySchoolId", params, "get", "");
}
//获取学校所有科室
export function schoolgetdepartmentlist(params) {
  return POST(urls + "/school/getdepartmentlist", params, "get", "");
}
//学校课程--保存
export function schoolCoursesaveSchoolCourse(params) {
  return POST(urls + "/schoolCourse/saveSchoolCourse", params, "post", "");
}
//学校课程--查询学校课程
export function schoolCoursequerySchoolCourse(params) {
  return POST(urls + "/schoolCourse/querySchoolCourse", params, "get", "");
}
//学校课程--删除
export function schoolCoursedelSchoolCourse(params) {
  return POST(
    urls + "/schoolCourse/delSchoolCourse?courseId=" + params.courseId,
    "",
    "post",
    ""
  );
}
//学校课程--国家课程发卡统计
export function schoolCourseschoolCourseCountryCount(params) {
  return POST(
    urls + "/schoolCourse/schoolCourseCountryCount",
    params,
    "get",
    ""
  );
}
//学校课程--校本课发卡统计
export function schoolCourseschoolCourseBaseCount(params) {
  return POST(urls + "/schoolCourse/schoolCourseBaseCount", params, "get", "");
}
//学校课程--校本课统计导出
export const schoolCourseexportCchoolCourseBaseCount =
  urls + "/schoolCourse/exportSchoolCourseBaseCount";
//学校课程--查询老师课程和班级信息
export function schoolCoursegetTeacherSchoolCourseResult(params) {
  return POST(
    urls + "/schoolCourse/getTeacherSchoolCourseResult",
    params,
    "get",
    ""
  );
}
//学校课程--老师课程发卡统计
export function schoolCourseschoolCourseTeacherCount(params) {
  return POST(
    urls + "/schoolCourse/schoolCourseTeacherCount",
    params,
    "get",
    ""
  );
}
//学校课程--国家课程统计导出
export const schoolCourseexportSchoolCourseCountryCount =
  urls + "/schoolCourse/exportSchoolCourseCountryCount";
//学校课程--查询老师课程信息详情
export function schoolCoursegetTeacherShoolCourseDetails(params) {
  return POST(
    urls + "/schoolCourse/getTeacherShoolCourseDetails",
    params,
    "get",
    ""
  );
}
//学校课程--老师端本班发卡详情导出
export const schoolCourseexportSchoolCourseCardDetails =
  urls + "/schoolCourse/exportSchoolCourseCardDetails";
//评价指标-获取学校某个等级下所有指标
export function nodesgetListByLevel(params) {
  return POST(urls + "/nodes/getListByLevel", params, "get", "");
}

//活动-批量删除活动结果
export function activitybatchdel(params) {
  return POST(urls + "/activity/batch/del", params, "get", "");
}
//获取教师任教详情（包含班主任）
export function teachersubjectdetail(params) {
  return POST(urls + "/teacher/subject/detail", params, "get", "");
}
//寄语管理-pc端班主任寄语列表
export function summaryteachlist(params) {
  return POST(urls + "/summary/teach/list", params, "get", "");
}
//寄语管理-寄语模板下载
export const summarydownload = urls + "/summary/download";
//寄语管理-寄语导入
// export function summaryimport(params) {
// 	return POST(urls + '/summary/import', params, 'post', '')
// }
export const summaryimport = urls + "/summary/import";
//寄语管理-提交寄语
export function summarysubmit(params) {
  return POST(urls + "/summary/submit", params, "post", "");
}
//体质健康测试-体质健康测试列表
export function physicallist(params) {
  return POST(urls + "/physical/list", params, "get", "");
}
//体质健康测试-体测模板下载
export const physicaldownload = urls + "/physical/download";
//体质健康测试-体测数据导入
export const physicalimport = urls + "/physical/import";
//体质健康测试-体测数据导出
export const physicalexport = urls + "/physical/export";
//教师评价-获取考试类型
export function tchmanagergetExamTypes(params) {
  return POST(urls + "/tch/manager/getExamTypes", params, "get", "");
}
//综评档案-列表
export function archiveslist(params) {
  return POST(urls + "/archives/list", params, "get", "");
}
//体质健康测试-体质健康测试项说明列表
export function physicaldesc(params) {
  return POST(urls + "/physical/desc", params, "get", "");
}
//体质健康测试-体质健康测试项说明列表
export function reportformlist(params) {
  return POST(urls + "/report/form/list", params, "get", "");
}
// 教师导出本班级学生
export function teacherExport(params, name) {
  return DWON(
    urls +
      "/tch/manager/export?classId=" +
      params.classId +
      "&typeId=" +
      params.typeId +
      "&gradeId=" +
      params.gradeId +
      "&termId=" +
      params.termId +
      "&name=" +
      params.name,
    "get",
    name
  );
}
// 批量删除学生成绩
export function delScore(params) {
  return POST(urls + "/tch/manager/del/score", params, "post", "");
}
// 统计年级报告进度详情
export function selectDetails(params) {
  return POST(
    urls + "/evaluateReportProgress/selectGradeProgressDetails",
    params,
    "get",
    ""
  );
}
// 统计年级报告进度详情导出
export function exportGradeDetail(params, name) {
  return DWON(
    urls +
      "/evaluateReportProgress/exportSelectGradeProgressDetails?appCode=ZHSZPJ" +
      "&gradeId=" +
      params.gradeId +
      "&termId=" +
      params.termId +
      "&componentType=" +
      params.componentType,
    "get",
    name
  );
}
// 活动记录导出
export function importActivityRecords(params, name) {
  return DWON(
    urls +
      "/activitycard/importActivityRecords?appCode=ZHSZPJ" +
      "&id=" +
      params.id +
      "&schoolId=" +
      params.schoolId +
      "&isAward=" +
      params.isAward +
      "&pageNo=" +
      params.pageNo +
      "&pageSize=" +
      params.pageSize,
    "get",
    name
  );
}
// 分页查询班级报告进度详情
export function selectClassDetails(params) {
  return POST(
    urls + "/evaluateReportProgress/selectClassProgressDetails",
    params,
    "get",
    ""
  );
}
// 班级报告进度详情导出
export function exportClassDetail(params, name) {
  return DWON(
    urls +
      "/evaluateReportProgress/exportSelectClassProgressDetails?appCode=ZHSZPJ" +
      "&gradeId=" +
      params.gradeId +
      "&termId=" +
      params.termId +
      "&classesId=" +
      params.classesId +
      "&studentName=" +
      params.studentName +
      "&componentType=" +
      params.componentType,
    "get",
    name
  );
}
// 获取学生成长报告册
export function reportGetDetail(params) {
  return POST(urls + "/report/book/getDetail", params, "get", "");
}

//通过学校Id 查询学校所有课程
export function getSubjectBySchoolId(params) {
  return POST(urls + "/subject/getSubjectBySchoolId", params, "get", "");
}
// 根据学科删除成绩
export function delScoreSubject(params) {
  return POST(urls + "/tch/manager/del-score-by-subject", params, "post", "");
}
// 批量驳回 与 通过
export function batchUpdateStatus(params) {
  return POST(urls + "/tch/audit/v2/batch/update/status", params, "post", "");
}
// 评价-同步成绩
export function syncSubjectScore(params) {
  return POST(urls + "/tch/manager/sync-subject-score", params, "post", "");
}
// 查询学生档案
export function appletList(params) {
  return POST(urls + "/summary/applet/list", params, "get", "");
}
// 学校课程--根据学科查询对应的所带班级
export function getTeacherClassesByCourseId(params) {
  return POST(
    urls + "/schoolCourse/getTeacherClassesByCourseId",
    params,
    "get",
    ""
  );
}
// 评价小组-- 一键添加班级审核小组
export function oneKeyEvaGroup(params) {
  return POST(urls + "/eva/group/oneKeyEvaGroup", params, "post", "");
}
// 根据学校ID查询该区域下的活动类型
export function selectBySchoolId(params) {
  return POST(urls + "/activities/selectBySchoolId", params, "get", "");
}
// 企业微信登录
export function authLogin(params) {
  return POST(urls + "/user/qy/wx/authLogin", params, "post", "");
}
//评价模板-检测学校初始配置状态
export function getCheckStatus(params) {
  return POST(urls + "/template/getCheckStatus", params, "get", "");
}
// 获取区域列表
export function getAreaList(params) {
  return POST(urls + "/area/list", params, "get", "");
}
//school/modify
export function schoolmodify(params) {
  return POST(urls + "/school/modify", params, "post", "");
}
//评价模板-根据学校获取系统通用模板
export function getTemplateShow(params) {
  return POST(urls + "/template/getTemplateShow", params, "get", "");
}
//评价模板-根据学校获取系统通用模板
export function setDefaultTemplate(params) {
  return POST(urls + "/template/setDefaultTemplate", params, "post", "");
}
// 获取学年列表
export function getYearTerm(params) {
  return POST(urls + "/year/get-year-term", params, "get", "");
}
// 查询区域学科
export function queryByOrgIdAndStage(params) {
  return POST(urls + "/subject/queryByOrgIdAndStage", params, "get", "");
}
// 导师双选--自定义设置班级预分配（管理端
export function getTutorDistributeConfig(params) {
  return POST(
    urls + "/tutorDouble/getTutorDistributeConfig",
    params,
    "get",
    ""
  );
}
// 保存导师双选课程配置
export function saveTutorDistributeConfig(params) {
  return POST(
    urls + "/tutorDouble/saveTutorDistributeConfig",
    params,
    "post",
    ""
  );
}
//导师分配（管理端）
export function selectTutorDoubleResultList(params) {
  return POST(
    urls + "/tutorDouble/selectTutorDoubleResultList",
    params,
    "get",
    ""
  );
}
//导入分配结果（管理端）
export const importTutorDoubleResult =
  urls + "/tutorDouble/importTutorDoubleResult";
//下载导入分配结果模版（管理端）
export const downloadImportTemplate =
  urls + "/tutorDouble/downloadImportTemplate";
//师双选--导出分配结果（管理端）
export const exportTutorDoubleResult =
  urls + "/tutorDouble/exportTutorDoubleResult";
//调剂学生（管理端）
export function queryAdjustStudentList(params) {
  return POST(urls + "/tutorDouble/queryAdjustStudentList", params, "get", "");
}
//分页查询设置导师（管理端）
export function queryTutorTeacherWorkList(params) {
  return POST(
    urls + "/tutorDouble/queryTutorTeacherWorkList",
    params,
    "get",
    ""
  );
}
//提交调剂的学生（管理端）
export function submitAdjustStudent(params) {
  return POST(urls + "/tutorDouble/submitAdjustStudent", params, "post", "");
}
//导师双选--基础配置状态（管理端）
export function getConifgStatus(params) {
  return POST(urls + "/tutorDouble/getConifgStatus", params, "get", "");
}
//分页查询导师双选活动
export function queryTutorDoubleElectorList(params) {
  return POST(
    urls + "/tutorDouble/queryTutorDoubleElectorList",
    params,
    "get",
    ""
  );
}
//保存导师双选活动
export function saveTutorDoubleElector(params) {
  return POST(urls + "/tutorDouble/saveTutorDoubleElector", params, "post", "");
}
//分页查询导师双选活动详情
export function queryTutorPreList(params) {
  return POST(urls + "/tutorDouble/queryTutorPreList", params, "get", "");
}
//导出导师双选活动详情
export const exportQueryTutorPreList =
  urls + "/tutorDouble/exportQueryTutorPreList";
//删除导师双选活动（管理端）
export function delTutorDoubleElector(params) {
  return POST(
    urls + "/tutorDouble/delTutorDoubleElector/" + params.id,
    "",
    "delete",
    ""
  );
}
export function qyTicket(params) {
  return POST(urls + "/usercenter/create-qyTicket", params, "post", "", 4);
}
//导师双选--获取已经分配指导结果的年级（管理端）
export function getTutorGuidedGrade(params) {
  return POST(urls + "/tutorDouble/getTutorGuidedGrade", params, "get", "");
}
//分页查询校本课程学生名单
export function querySchoolCourseStudent(params) {
  return POST(
    urls + "/schoolCourse/querySchoolCourseStudent",
    params,
    "get",
    ""
  );
}
//添加学生
export function saveSchooCourseStudent(params) {
  return POST(
    urls + "/schoolCourse/saveSchooCourseStudent",
    params,
    "post",
    ""
  );
}
//导入学生
export const importEnrollmentStudent =
  urls + "/schoolCourse/importEnrollmentStudent";
//导出学生
export const exportSchoolCourseStudent =
  urls + "/schoolCourse/exportSchoolCourseStudent";
// export function exportSchoolCourseStudent(params) {
// 	return POST(urls + '/schoolCourse/exportSchoolCourseStudent', params, 'post', '')
// }
//删除学生
export function delSchoolCourseStudent(params) {
  return POST(
    urls + "/schoolCourse/delSchoolCourseStudent/" + params.id,
    "",
    "delete",
    ""
  );
}
//归档学生
export function archiveSchoolCourseStudent(params) {
  return POST(
    urls + "/schoolCourse/archiveSchoolCourseStudent",
    params,
    "get",
    ""
  );
}
//开启课程
export function schoolCourseisOpen(params) {
  return POST(urls + "/schoolCourse/isOpen", params, "get", "");
}
//获取学校管理课程列表
export function getCardPointList(params) {
  return POST(`${urls}/curriculumManage/list`, params, "get", "");
}
//查看活动列表PC
export function listActivitiesPC(params) {
  return POST(`${urls}/activitycard/listActivitiesPC`, params, "get", "");
}
//获取所有活动分类（标签）
export function activityClassify(params) {
  return POST(`${urls}/activitycard/activityClassify`, params, "get", "");
}
//查看平台活动模板列表
export function listActivitiesTemplate(params) {
  return POST(`${urls}/activitycard/listActivitiesTemplate`, params, "get", "");
}
//勋章模板列表
export function listMedal(params) {
  return POST(`${urls}/medal/listMedal`, params, "get", "");
}
//打卡频次列表
export function frequencyType(params) {
  return POST(`${urls}/activitycard/frequencyType`, params, "get", "");
}
//打卡频次列表
export function publishActivityPC(params) {
  return POST(`${urls}/activitycard/publishActivityPC`, params, "post", "");
}
//活动详情
export function activityDetail(params) {
  return POST(`${urls}/activitycard/activityDetail`, params, "get", "");
}
// 一键清除教师分工
export function onClearTeacherDivision() {
  return POST(urls + "/teacher/work/remove_work_setting", "", "post", "");
}
// 教师分工删除（机构）
export function cancelTeacherWork(params) {
  return POST(urls + "/mechanism/cancelTeacherWork", params, "post", "");
}
// 验证班级和课程是否已经分配教师
export function verifyTeacherWork(params) {
  return POST(urls + "/mechanism/verifyTeacherWork", params, "get", "");
}
export function saveTeacherWork(params) {
  return POST(urls + "/mechanism/saveTeacherWork", params, "post", "");
}
// /mechanism/selectBaseEvaCourseType
export function selectCourseList(params) {
  return POST(urls + "/mechanism/selectMechanismCourseList", params, "get", "");
}
//校验是否已经设置分工
export function WorkCheckSubject(params) {
  return POST(urls + "/teacher/work/check_subject", params, "post", "");
}
// 保存教师分工
export function teacherWorkSetting(params) {
  return POST(urls + "/teacher/work/setting", params, "post", "");
}
// 查询角色
export function roleList(params) {
  return POST(urls + "/role/list", params, "get", "");
}

//删除该角色的用户
export function deletdRoleUser(params) {
  return POST(urls + "/role/user", params, "delete", "");
}
// 获取全部学科列表
export function subjectList(params) {
  return POST(urls + "/subject/getSubjectBySchoolId", params, "get", "");
}
// 根据学校ID获取年级列表
export function gradeClassList(params) {
  return POST(urls + "/grade/gradelist", params, "get", "");
}
// 获取教师列表
export function teacherLists(params) {
  return POST(urls + "/teacher/list", params, "get", "");
}
// 教师分配角色
export function roleUser(params) {
  return POST(urls + "/role/user", params, "post", "", 4);
}
// 删除教师
export function deleteTeacher(params) {
  return POST(urls + "/teacher/" + params, "", "delete", "");
}
// 获取全部科室列表
export function getdepartmentlist(params) {
  return POST(urls + "/school/getdepartmentlist", params, "get", "");
}
// 批量删除课程中的学生
export function batchDelSchoolCourseStudent(params) {
  return POST(
    urls + "/schoolCourse/batchDelSchoolCourseStudent",
    params,
    "post",
    ""
  );
}
// 获取活动作品列表
export function activityRecordsSchool(params) {
  return POST(urls + "/activitycard/activityRecordsSchool", params, "get", "");
}
// 给活动作品颁奖
export function awardActivityRecords(params) {
  return POST(urls + "/activitycard/awardActivityRecords", params, "post", "");
}
// 撤销颁奖
export function revokeActivityRecords(params) {
  return POST(urls + "/activitycard/revokeActivityRecords", params, "post", "");
}
//获取所有活动分类
export function getactivityClassify() {
  return POST(`${urls}/activitycard/activityClassify`, "", "get");
}
//添加活动模板，PC運營後台&學校
export function publishActivityTmp(params) {
  return POST(`${urls}/activitycard/publishActivityTmp`, params, "post", "");
}
//删除活动模板
export function deleteActivitiesTemplatePC(params) {
  return POST(
    `${urls}/activitycard/deleteActivitiesTemplatePC`,
    params,
    "get",
    ""
  );
}
//保存勋章模板
export function saveMedalTemplate(params) {
  return POST(`${urls}/medal/saveMedalTemplate`, params, "post", "");
}
//删除勋章
export function medalDel(params) {
  return POST(`${urls}/medal/del/${params.id}`, "", "DELETE", "");
}
//統計,PC校端
export function activityRecordsTJ(params) {
  return POST(`${urls}/activitycard/activityRecordsTJ`, params, "get", "");
}
//获取评优列表
export function goodType(params) {
  return POST(`${urls}/activitycard/goodType`, params, "get", "");
}
//导入课程行为
export const curriculumport = `${urls}/curriculumManage/coursePoint/import`;
//下载课程行为导入模板
export const curriculumManagedownloadtemplate = `${urls}/curriculumManage/download/template`;
//发起测评列表(没有ID说明学校还没发起测评)
export function getPaperList(params) {
  return POST(`${urls}/subjectivity/activity/list`, params, "get", "");
}
//获取试卷信息
export function getPaperInfo(params) {
  return POST(`${urls}/subjectivity/paper/${params.id}`, {}, "get", "");
}
//预览试题
export function paperPreview(params) {
  return POST(`${urls}/subjectivity/paper/preview/${params.id}`, {}, "get", "");
}
//发起测评详情
export function getTestInfo(params) {
  return POST(
    `${urls}/subjectivity/activity/${params.id}`,
    { evaluationId: params.evaluationId },
    "get",
    ""
  );
}
//发起/修改测评(年级列表只能新增不能删除)
export function saveTest(params) {
  return POST(`${urls}/subjectivity/activity`, params, "post", "");
}
//学生答题查询
export function getTestDetail(params) {
  return POST(`${urls}/subjectivity/activity/detail`, params, "get", "");
}
//班级列表
export function getClassesList(params) {
  return POST(`${urls}/classes/list`, params, "get", "");
}
//学生试卷已选项
export function getScoreDetail(params) {
  return POST(`${urls}/subjectivity/score/detail`, params, "get", "");
}
//用户登录接口
export function userlogin(params) {
  return POST(urls + "/user/login", params, "post", "", 4);
}
//数据概览
export function schoolDataOverview(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/schoolDataOverview`,
    params,
    "get",
    ""
  );
}
//荣誉统计
export function schoolHonourStatistics(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/schoolHonourStatistics`,
    params,
    "get",
    ""
  );
}
//活动课程统计
export function schoolActivityClassifyStatistics(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/schoolActivityClassifyStatistics`,
    params,
    "get",
    ""
  );
}
// 获取角色信息
export function roleByUser(params) {
  return POST(urls + "/role/list/by-user", params, "get", "");
}
//获取表单列表
export function getSampleList(params) {
  return POST(urls + "/component/list", params, "get", "");
}
//组件-获取组件元素列表
export function ComponentDetailList(params) {
  return POST(`${urls}/component/detail/list`, params, "get", "");
}
//获取服务学校的基地
export function getSiteBySchool(params) {
  return POST(`${urls}/site/getSiteBySchool`, params, "get", "");
}
//分页查询社区活动（学校pc端），服务于该学校的社区
export function querySchoolSiteActivities(params) {
  return POST(`${urls}/site/querySchoolSiteActivities`, params, "get", "");
}
//学校引入基地(学校pc端)
export function bringIn(params) {
  return POST(`${urls}/site/bringIn`, params, "post", "");
}
//学校引入基地活动（学校pc端）
export function bringInActivities(params) {
  return POST(`${urls}/site/bringInActivities`, params, "get", "");
}
//兴趣爱好与艺术特长统计
export function interestAdvantageStatistics(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/interestAdvantageStatistics`,
    params,
    "get",
    ""
  );
}
//体质健康统计
export function physicalStatistics(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/physicalStatistics`,
    params,
    "get",
    ""
  );
}
//学业成绩统计
export function subjectStatistics(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/subjectStatistics`,
    params,
    "get",
    ""
  );
}
//评价统计
export function subjectivityStatistics(params) {
  return POST(
    `${urls}/schoolHomePageStatistics/subjectivityStatistics`,
    params,
    "get",
    ""
  );
}
//获取校长报告列表
export function getRectorReport(params) {
  return POST(`${urls}/reports/getRectorReport`, params, "get", "");
}
//生成学校报告
export function creatSchoolReport(params) {
  return POST(`${urls}/reports/creatSchoolReport`, params, "get", "");
}
//获取报告详情
export function getSchoolReportDetail(params) {
  return POST(`${urls}/reports/getSchoolReportDetail`, params, "get", "");
}
//数据中心/学生统计/各个年级统计
export function getStudentGradeStatistics(params) {
  return POST(
    `${urls}/dataCenter/getStudentGradeStatistics`,
    params,
    "post",
    ""
  );
}
//数据中心/学生统计/各个班级统计
export function getStudentClassStatistics(params) {
  return POST(
    `${urls}/dataCenter/getStudentClassStatistics`,
    params,
    "get",
    ""
  );
}
//数据中心/学生统计
export function getStudentStatistics(params) {
  return POST(`${urls}/dataCenter/getStudentStatistics`, params, "get", "");
}
//数据中心/测评统计/各个年级统计
export function getSubjectivityGradeStatistics(params) {
  return POST(
    `${urls}/dataCenter/getSubjectivityGradeStatistics`,
    params,
    "post",
    ""
  );
}
//数据中心/测评统计/各个班级统计
export function getSubjectivityClassStatistics(params) {
  return POST(
    `${urls}/dataCenter/getSubjectivityClassStatistics`,
    params,
    "get",
    ""
  );
}
//数据中心/测评统计/概况统计
export function getSubjectivityStatistics(params) {
  return POST(
    `${urls}/dataCenter/getSubjectivityStatistics`,
    params,
    "post",
    ""
  );
}
//数据中心/测评统计/班级统计/学校个人信息统计
export function getSubjectivityStudentStatistics(params) {
  return POST(
    `${urls}/dataCenter/getSubjectivityStudentStatistics`,
    params,
    "get",
    ""
  );
}
//学生基本信息
export function getStudentInfo(params) {
  return POST(urls + "/student/" + params.id, params, "get", "");
}
//数据中心/社区统计
export function getSiteStattistics(params) {
  return POST(`${urls}/dataCenter/getSiteStattistics`, params, "post", "");
}
//数据中心/兴趣特长统计
export function getHobbiesStatistics(params) {
  return POST(`${urls}/dataCenter/getHobbiesStatistics`, params, "post", "");
}
//根据学段获取年级
export function getGradeList(params) {
  return POST(urls + "/grade/stage-list", params, "get", "");
}
//数据中心/兴趣特长统计/各个班级统计
export function getHobbiesClassStatistics(params) {
  return POST(
    `${urls}/dataCenter/getHobbiesClassStatistics`,
    params,
    "get",
    ""
  );
}
//数据中心/兴趣特长统计/各个学生统计
export function getHobbiesStudentStatistics(params) {
  return POST(
    `${urls}/dataCenter/getHobbiesStudentStatistics`,
    params,
    "get",
    ""
  );
}
//数据中心/荣誉统计/荣誉等级统计(区域、学校、年级、班级)
export function getHonorTypeStatistics(params) {
  return POST(`${urls}/dataCenter/getHonorTypeStatistics`, params, "post", "");
}
//数据中心/荣誉统计/荣誉类别统计(区域、学校、年级、班级)
export function getHonorCategoryStatistics(params) {
  return POST(
    `${urls}/dataCenter/getHonorCategoryStatistics`,
    params,
    "post",
    ""
  );
}
//数据中心/荣誉统计/荣誉等级类别统计
export function getHonorTypeCategoryStatisticsList(params) {
  return POST(
    `${urls}/dataCenter/getHonorTypeCategoryStatisticsList`,
    params,
    "post",
    ""
  );
}
//数据中心/荣誉统计/班级/各个学生个人信息统计
export function getHonorStudentStatisticsList(params) {
  return POST(
    `${urls}/dataCenter/getHonorStudentStatisticsList`,
    params,
    "get",
    ""
  );
}
//数据中心/活动统计/各个年级统计
export function getActivityGradeStatisticsList(params) {
  return POST(
    `${urls}/dataCenter/getActivityGradeStatisticsList`,
    params,
    "post",
    ""
  );
}
//数据中心/活动统计/各个班级统计
export function getActivityClassStatistics(params) {
  return POST(
    `${urls}/dataCenter/getActivityClassStatistics`,
    params,
    "get",
    ""
  );
}
//数据中心/活动统计/学生个人信息统计
export function getStudentStatisticsList(params) {
  return POST(`${urls}/dataCenter/getStudentStatisticsList`, params, "get", "");
}
//数据中心/活动统计
export function getActivityStatistics(params) {
  return POST(`${urls}/dataCenter/getActivityStatistics`, params, "post", "");
}
//数据中心/活动统计/五育下活动统计
export function getActivityFiveBirthsStatistics(params) {
  return POST(
    `${urls}/dataCenter/getActivityFiveBirthsStatistics`,
    params,
    "post",
    ""
  );
}
//数据中心/体质健康统计/概况统计(学校、年级、班级)
export function getPhysicalStatistics(params) {
  return POST(`${urls}/dataCenter/getPhysicalStatistics`, params, "get", "");
}
//数据中心/体质健康统计/各个学生统计
export function getPhysicalStudentStatistics(params) {
  return POST(
    `${urls}/dataCenter/getPhysicalStudentStatistics`,
    params,
    "get",
    ""
  );
}
//数据中心/学业统计/年级/学科统计
export function getScoreStatisticsList(params) {
  return POST(`${urls}/dataCenter/getScoreStatisticsList`, params, "post", "");
}
//数据中心/学业统计/年级/学科统计
export function getScoreGradeSubjectStatistics(params) {
  return POST(
    `${urls}/dataCenter/getScoreGradeSubjectStatistics`,
    params,
    "post",
    ""
  );
}
//数据中心/学业统计/各个年级统计
export function getScoreGradeStatistics(params) {
  return POST(`${urls}/dataCenter/getScoreGradeStatistics`, params, "post", "");
}
//数据中心统计/学业统计/年级/班级统计
export function getScoreClassStatistics(params) {
  return POST(`${urls}/dataCenter/getScoreClassStatistics`, params, "get", "");
}
//数据中心/学业统计/班级/学生个人信息统计
export function getScoreStudentStatistics(params) {
  return POST(
    `${urls}/dataCenter/getScoreStudentStatistics`,
    params,
    "get",
    ""
  );
}
//教师任务监测
export function teacherSchedule(params) {
  return POST(`${urls}/schedule/teacherSchedule`, params, "get", "");
}
//教师任务监测详情
export function teacherScheduleDetail(params) {
  return POST(`${urls}/schedule/teacherScheduleDetail`, params, "get", "");
}

//学生任务监测
export function studentSchedule(params) {
  return POST(`${urls}/schedule/studentSchedule`, params, "get", "");
}

//学生任务监测详情
export function studentScheduleDetail(params) {
  return POST(`${urls}/schedule/studentScheduleDetail`, params, "get", "");
}
//评价阶段-获取当前评价阶段时间轴
export function getIndexTimeLine(params) {
  return POST(`${urls}/stage/time-line`, params, "get", "");
}
// 修改密码
export function changePassword(params) {
  return POST(
    `${urls}/usercenter/modify-password-by-old`,
    params,
    "post",
    "",
    4
  );
}
//基础信息统计(学校首页/学校数据大屏)
export function getReadStatisticsBase(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/getReadStatisticsBase`,
    params,
    "get",
    ""
  );
}
//在读图书TOP10（学校首页/学校数据大屏）
export function statisticsBookCount(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/statisticsBookCount`,
    params,
    "get",
    ""
  );
}
//在读年级人数统计（学校首页）
export function statisticsGradeCount(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/statisticsGradeCount`,
    params,
    "get",
    ""
  );
}
//在读图书类型统计（学校首页/学校数据大屏）
export function statisticsClassifyCount(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/statisticsClassifyCount`,
    params,
    "get",
    ""
  );
}
//分页查询阅读任务
export function queryReadTaskList(params) {
  return POST(`${BASE_URL}/read/read-task/queryList`, params, "get", "");
}
//分页查询书籍（阅读任务场景使用）
export function taskQueryList(params) {
  return POST(`${BASE_URL}/read/read-books/taskQueryList`, params, "get", "");
}
//分页查询书单（阅读任务场景使用）
export function taskQueryBillList(params) {
  return POST(`${BASE_URL}/read/read-bill/taskQueryList`, params, "get", "");
}
//保存阅读任务
export function saveReadTask(params) {
  return POST(`${BASE_URL}/read/read-task/saveReadTask`, params, "post", "");
}
//发布任务
export function publishTask(params) {
  return POST(`${BASE_URL}/read/read-task/publish`, params, "get", "");
}
//删除任务
export function delTask(params) {
  return POST(`${BASE_URL}/read/read-task/del`, params, "get", "");
}
//获取任务详情
export function getTaskDetail(params) {
  return POST(`${BASE_URL}/read/read-task/getDetail`, params, "get", "");
}
//分页查询书籍
export function queryBookList(params) {
  return POST(`${BASE_URL}/read/read-books/querySchoolList`, params, "get");
}
// 根据学段获取年级列表
export function getGradeStage(params) {
  return POST(`${BASE_URL}/evaluate/grade/stage-list`, params, "get");
}
//保存书籍
export function saveReadBooks(params) {
  return POST(`${BASE_URL}/read/read-books/saveReadBooks`, params, "post");
}
// 根据id获取阅读书籍详情
export function getBookDetail(params) {
  return POST(`${BASE_URL}/read/read-books/getDetail`, params, "get");
}
// 获取出版社列表
export function getPublishingList(params) {
  return POST(`${BASE_URL}/read/read-books/getPublishingList`, params, "get");
}
// 更新阅读书籍的发布状态
export function modifyPublishStatus(params) {
  return POST(`${BASE_URL}/read/read-books/modifyPublishStatus`, params, "get");
}
// 根据阅读书籍id获取阅读题库列表
export function getListByBookId(params) {
  return POST(`${BASE_URL}/read/read-question/getListByBookId`, params, "get");
}
//保存阅读题库
export function saveReadQuestion(params) {
  return POST(
    `${BASE_URL}/read/read-question/saveReadQuestion`,
    params,
    "post"
  );
}
//设置测评规则
export function setUpPaperRule(params) {
  return POST(`${BASE_URL}/read/read-books/setUpPaperRule`, params, "post");
}
// 删除试题
export function delQuestion(params) {
  return POST(`${BASE_URL}/read/read-question/del`, params, "get");
}
//保存阅读资源
export function saveReadResource(params) {
  return POST(
    `${BASE_URL}/read/read-resource/saveReadResource`,
    params,
    "post"
  );
}
// 根据阅读书籍id获取配套资源
export function getResourceByBookId(params) {
  return POST(`${BASE_URL}/read/read-resource/getListByBookId`, params, "get");
}
// 删除书籍配套资源
export function delRes(params) {
  return POST(`${BASE_URL}/read/read-resource/del`, params, "get");
}
// 删除书籍
export function delBook(params) {
  return POST(`${BASE_URL}/read/read-books/del`, params, "get");
}
// 查询书单
export function queryBillList(params) {
  return POST(`${BASE_URL}/read/read-bill/queryList`, params, "get");
}
// 删除书单
export function delBill(params) {
  return POST(`${BASE_URL}/read/read-bill/del`, params, "get");
}
// 更新阅读书单的发布状态
export function modifyBillPublishStatus(params) {
  return POST(`${BASE_URL}/read/read-bill/modifyPublishStatus`, params, "get");
}
//保存阅读书单
export function saveReadBill(params) {
  return POST(`${BASE_URL}/read/read-bill/saveReadBill`, params, "post");
}
// 根据id获取阅读书单详情
export function getBillDetail(params) {
  return POST(`${BASE_URL}/read/read-bill/getDetail`, params, "get");
}
// 更新阅读书籍的下架状态
export function modifyDelistStatus(params) {
  return POST(`${BASE_URL}/read/read-books/modifyDelistStatus`, params, "get");
}
// 更新阅读书籍的下架状态
export function modifyBillDelistStatus(params) {
  return POST(`${BASE_URL}/read/read-bill/modifyDelistStatus`, params, "get");
}
//获取学校全部阅读分类列表-树形结构
export function getTreeReadClassify(params) {
  return POST(
    `${BASE_URL}/read/read-classify/treeListBySchoolId`,
    params,
    "get",
    ""
  );
}
// 下载导入图书模板
export function exportReadBookTemplate() {
  return DWON(`${BASE_URL}/read/export/exportReadBookTemplate`, "post", "");
}
//年级统计（阅读统计）
export function readStatisticsGradeCount(params) {
  return POST(`${BASE_URL}/read/readStatistics/gradeCount`, params, "get", "");
}
//班级统计（阅读统计）
export function readStatisticsClassCount(params) {
  return POST(`${BASE_URL}/read/readStatistics/classCount`, params, "get", "");
}
//学生统计（阅读统计）
export function readStatisticsStudentCount(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/studentCount`,
    params,
    "get",
    ""
  );
}
//学生阅读详情（阅读统计）
export function readStatisticsStudentDetail(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/studentDetail`,
    params,
    "get",
    ""
  );
}
//学生阅读书籍列表（阅读统计）
export function readStatisticsStudentDetailList(params) {
  return POST(
    `${BASE_URL}/read/readStatistics/studentDetailList`,
    params,
    "get",
    ""
  );
}
export function resourcequeryList(params) {
  return POST(`${BASE_URL}/read/read-resource/queryList`, params, "get");
}
export function resourcelinkBook(params) {
  return POST(`${BASE_URL}/read/read-resource/linkBook`, params, "post",'',4);
}
export function worksave(params) {
  return POST(`${BASE_URL}` + '/read/read-work/save', params, 'post','',4)
}
export function workgetListByBookId(params) {
  return POST(`${BASE_URL}` + '/read/read-work/getListByBookId', params, 'get','')
}
export function ComponentList(params) {
  return POST(`${BASE_URL}/evaluate/component/list`, params, "get", "");
}
export function batchAddToSchoolBooks(params) {
  return POST(`${BASE_URL}/read/read-books/batchAddToSchoolBooks`, params, "post", "",4);
}
export function resourcedel(params) {
  return POST(`${BASE_URL}` + '/read/read-resource/del', params, 'get','')
}
export function resourcegetInfo(params) {
  return POST(`${BASE_URL}` + '/read/read-resource/getInfo', params, 'get', '')
}
export function queryVideoList(params) {
  return POST(`${BASE_URL}` + '/evaluate/file/getOssFileList', params, 'get', '')
}
export function resourcesave(params) {
  return POST(`${BASE_URL}/read/read-resource/save`, params, "post");
}
export function batchRemoveFromSchoolBooks(params) {
  return POST(`${BASE_URL}/read/read-books/batchRemoveFromSchoolBooks`, params, "post", "",4);
}
export function queryList(params) {
  return POST(`${BASE_URL}/read/read-books/queryList`, params, "get", "");
}
export function queryStudentList(params) {
  return POST(`${BASE_URL}/read/read-task/queryStudentList`, params, "get", "");
}
export function bookList(params) {
  return POST(`${BASE_URL}/read/readStatistics/bookList`, params, "get", "");
}
export function studentCount(params) {
  return POST(`${BASE_URL}/read/readStatistics/studentCount/export`, params, "get", "");
}
export function getStudentStarRecord(params) {
  return POST(`${BASE_URL}/read/readStatistics/getStudentStarRecord`, params, "get", "");
}
export function removeresource(params) {
  return POST(`${BASE_URL}` + '/read/read-resource/remove', params, 'get')
}


// WEBPACK FOOTER //
// ./src/api/home.js